import dayjs, { Dayjs } from "dayjs";
import { DATE_FORMAT_TO_COMPARE } from "us.collection/constants";

/**
 * @function
 * @description - to determine if the date parameter passed is as same as the date today
 * @param {(Dayjs | undefined)} pickedDate - the date to be compared
 * @return {*}  {boolean} - the decision if the date is the same
 */
export const isSameDate = (pickedDate: Dayjs | undefined):boolean =>
dayjs(dayjs(pickedDate).format(DATE_FORMAT_TO_COMPARE)).isSame(
  dayjs().startOf("day").format(DATE_FORMAT_TO_COMPARE)
);